import { ReactNode } from 'react'
import styled, { css } from 'styled-components'

import { theme } from '@/styles/theme'

type SectionTitleBackgroundProps = {
  children: ReactNode
  bgColor: 'white' | 'trial-blue' | 'thin-blue'
  outerBgColor: 'white' | 'thin-blue'
  /** 先頭セクションなど、上部矢印が不要な場合は false */
  showTopArrow?: boolean
  padding: {
    pc: string
    sp: string
  }
}

export const SectionTitleBackground = ({
  children,
  showTopArrow = true,
  ...rest
}: SectionTitleBackgroundProps) => {
  return (
    <Wrapper showTopArrow={showTopArrow} {...rest}>
      {children}
    </Wrapper>
  )
}

const Arrow = css`
  content: '';
  position: absolute;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 175px 50vw 0 50vw;

  @media screen and (max-width: 1047px) {
    border-width: 40px 50vw 0 50vw;
  }
`

const Wrapper = styled.div<Omit<SectionTitleBackgroundProps, 'children'>>`
  position: relative;
  background-color: ${({ bgColor }) =>
    bgColor === 'trial-blue'
      ? `${theme.colors.trialBlue}`
      : bgColor === 'thin-blue'
      ? `${theme.colors.backgroundBlue}`
      : '#fff'};
  padding: ${({ padding }) => padding.pc};

  &::before {
    ${({ showTopArrow = true, outerBgColor }) =>
      showTopArrow
        ? css`
            ${Arrow};
            top: 0;
            border-color: ${outerBgColor === 'thin-blue'
                ? theme.colors.backgroundBlue
                : '#fff'}
              transparent transparent transparent;
          `
        : css`
            content: none;
          `};
  }

  &::after {
    ${Arrow};
    bottom: 0;
    border-color: ${({ bgColor, outerBgColor }) =>
      `${
        bgColor === 'trial-blue'
          ? `${theme.colors.trialBlue}`
          : bgColor === 'thin-blue'
          ? `${theme.colors.backgroundBlue}`
          : '#fff'
      } 
      ${
        outerBgColor === 'thin-blue' ? `${theme.colors.backgroundBlue}` : '#fff'
      } 
      transparent 
      ${
        outerBgColor === 'thin-blue' ? `${theme.colors.backgroundBlue}` : '#fff'
      }`};
  }

  @media screen and (max-width: 1047px) {
    padding: ${({ padding }) => padding.sp};
  }
`
